<div class="auth-layout" [class.auth-layout--split]="variant === 'split'">
  <ng-container *ngIf="variant === 'scene'; else split">
    <app-login-scene></app-login-scene>

    <div class="auth-card-slot">
      <section class="card">
        <img class="form-logo" src="assets/img/logo-FTCloud-white.svg" alt="FT Pilot">

        <ng-container *ngTemplateOutlet="content"></ng-container>

        <div class="lang-box" *ngIf="languages.length && currentLanguage" role="group" [attr.aria-label]="'user.login.changeLanguage' | transloco">
          <ng-container *ngTemplateOutlet="langOptions"></ng-container>
        </div>

        <div class="card-footer">FuelTech</div>
      </section>
    </div>
  </ng-container>

  <ng-template #split>
    <aside class="auth-aside">
      <div class="aside-pattern" aria-hidden="true">
        <svg width="560" height="640" viewBox="0 0 560 640" fill="none">
          <defs>
            <pattern id="auth-aside-hex" width="104" height="180" patternUnits="userSpaceOnUse">
              <g stroke="#202329" stroke-width="1.5">
                <polygon points="0,-60 52,-30 52,30 0,60 -52,30 -52,-30"/>
                <polygon points="104,-60 156,-30 156,30 104,60 52,30 52,-30"/>
                <polygon points="52,30 104,60 104,120 52,150 0,120 0,60"/>
                <polygon points="0,120 52,150 52,210 0,240 -52,210 -52,150"/>
                <polygon points="104,120 156,150 156,210 104,240 52,210 52,150"/>
              </g>
            </pattern>
          </defs>
          <rect width="560" height="640" fill="url(#auth-aside-hex)"/>
        </svg>
      </div>

      <img class="aside-logo" src="assets/img/logo-FTCloud-white.svg" alt="FT Pilot">

      <div>
        <h1 class="aside-headline">{{ headline }}</h1>
        <p class="aside-tagline" *ngIf="tagline">{{ tagline }}</p>
        <div class="aside-rule"></div>
      </div>

      <img class="aside-wordmark" src="assets/img/login/fueltech-logo-white.png" alt="FuelTech">
    </aside>

    <main class="auth-main">
      <div class="lang-box" *ngIf="languages.length && currentLanguage" role="group" [attr.aria-label]="'user.login.changeLanguage' | transloco">
        <ng-container *ngTemplateOutlet="langOptions"></ng-container>
      </div>

      <div class="auth-form-col">
        <ng-container *ngIf="stepSegments.length">
          <div class="step-bar" aria-hidden="true">
            <i *ngFor="let on of stepSegments" [class.on]="on"></i>
          </div>
          <div class="step-label">{{ 'user.authAside.stepOf' | transloco: { current: step, total: stepCount } }}</div>
        </ng-container>

        <ng-container *ngTemplateOutlet="content"></ng-container>
      </div>
    </main>
  </ng-template>
</div>

<ng-template #content><ng-content></ng-content></ng-template>

<ng-template #langOptions>
  <button
    *ngFor="let option of languages"
    class="lang-option"
    type="button"
    [class.active]="option.name === currentLanguage?.name"
    [disabled]="option.name === currentLanguage?.name"
    [attr.aria-pressed]="option.name === currentLanguage?.name"
    [attr.aria-label]="languageLabels[option.name]"
    (click)="languageChange.emit(option)"
  >
    <span [class]="option.class"></span>
  </button>
</ng-template>
